import type { LoggingContext, LoggingHandler } from "../../logging/types";

export const clearRecordedLogs = () => {
  recordedLogs.length = 0;
  expectedLogs.clear();
};

export const getRecordedLogs = (): LoggingContext[] => {
  return [...recordedLogs];
};

export const addExpectedLogs = (logs: LoggingContext[]) => {
  logs.forEach((log) => expectedLogs.add(log));
};

export const getExpectedLogs = (): Set<LoggingContext> => {
  return new Set<LoggingContext>(expectedLogs);
};

const expectedLogs: Set<LoggingContext> = new Set();
const recordedLogs: LoggingContext[] = [];

export const unitTestLoggingHandler: LoggingHandler = (context) => {
  recordedLogs.push(context);
};
